<script>
import VoixAdmin from "@voix/voix-layer/components/VoixAdmin.vue";
import { useRoute } from "vue-router";
import { useAdminStore } from "@voix/store/adminStore";
import { usePageStore } from "@voix/store/pageStore";
import { useLayoutStore } from "@voix/store/layoutStore";
import { useVoixToast } from "@voix/composables/useVoixToast";
import { computed, defineComponent, onBeforeUnmount, onMounted } from "vue";
import { useSliceStore } from "@voix/store/sliceStore";
import { useHead, useState } from "#imports";
export default defineComponent({
  components: {
    // eslint-disable-next-line vue/no-unused-components
    VoixAdmin
  },
  setup() {
    const adminStore = useAdminStore();
    const pageStore = usePageStore();
    useLayoutStore();
    useSliceStore();
    const route = useRoute();
    useHead({
      link: [
        {
          rel: "preconnect",
          href: "https://rsms.me/"
        },
        {
          rel: "stylesheet",
          href: "https://rsms.me/inter/inter.css"
        }
      ]
    });
    const section = computed(() => {
      if (route.path.includes("studio"))
        return "editor";
      if (route.path.includes("settings"))
        return "settings";
      if (route.path.includes("templatizer"))
        return "templatizer";
      return "unknown";
    });
    const voixToast = useVoixToast();
    const hasToasts = computed(() => {
      return voixToast.messages.length;
    });
    const voixDebug = useState("voixDebug");
    onMounted(() => {
      useHead({
        bodyAttrs: {
          class: "overflow-hidden"
        }
      });
    });
    onBeforeUnmount(() => {
      useHead({
        bodyAttrs: {
          class: ""
        }
      });
    });
    return {
      adminStore,
      pageStore,
      section,
      voixToast,
      hasToasts,
      voixDebug
    };
  }
});
</script>

<template>
  <div>
    <VoixAdminTheme>
      <ClientOnly>
        <LazyVoixAdmin>
          <NuxtPage
            :current-scale="adminStore.currentScale" class="transform duration-200 min-h-screen" :class="{
              'pl-[280px]': section !== 'unknown' && !adminStore.isZenMode,
              'pl-[30px]': section !== 'unknown' && adminStore.isZenMode,
            }"
          />
          <div
            v-if="voixDebug"
            class="absolute z-50 bottom-0 left-0 rounded-tr-lg w-full max-w-lg bg-white text-xs text-gray-400 p-8 border border-gray-200 border-r-gray-300"
          >
            <button class="absolute top-0 right-0 m-2 flex items-center space-x-1" @click="voixDebug = null">
              <span class="uppercase">Close</span>
              <svg
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                class="w-5 h-5"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <pre
              class="p-4 rounded bg-gray-300 text-gray-800 max-h-[50vh]  overflow-scroll font-voix-mono"
            >{{ voixDebug }}</pre>
          </div>
        </LazyVoixAdmin>
      </ClientOnly>
    </VoixAdminTheme>
  </div>
</template>
